import React, { useMemo } from 'react'
import { View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { useSelector } from 'react-redux'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Text } from '@src/components/base/Text'
import { UserPropertyOnboardingExperienceKind } from '@src/types'
import { userSelector } from '@src/selectors/app'
import { Button } from '@src/components/base'
import { statsSelector } from '@src/screens/Insights/models/insights.selectors'
import { PaidCallCreditsCard } from '@screens/Home/components/MyPlan/PaidCallCreditsCard.tsx'
import { useRecurrenceCallProgressCard } from '@screens/Home/components/MyPlan/hooks/useRecurrenceCallProgressCard.ts'
import { usePaidCallCreditsCard } from '@screens/Home/components/MyPlan/hooks/usePaidCallCreditsCard.ts'
import { RecurrenceCallCardProgress } from './RecurrenceCallCardProgress.tsx'

export const MyPlan = () => {
  const styles = useStyleSheet(themedStyle)
  const navigation = useNavigation()
  const stats = useSelector(statsSelector)
  const user = useSelector(userSelector)
  const onboardingExperience = user?.onboardingExperience
  const weightLossUser =
    onboardingExperience?.kind === UserPropertyOnboardingExperienceKind.WeightLoss &&
    onboardingExperience.participating

  const {
    isVisible: recurrenceCallCardVisible,
    props: recurrenceCallCardProps,
  } = useRecurrenceCallProgressCard()

  const {
    isVisible: paidCallCreditsCardVisible,
    props: paidCallCreditsCardProps,
  } = usePaidCallCreditsCard()

  const weightStatistic = useMemo(() => {
    return stats.find((stat) => stat.meta.key === 'weight')
  }, [stats])

  const handleOnWeightProgressPress = () => {
    if (!weightStatistic) {
      return
    }

    navigation.navigate('InsightsDetailedPage', {
      statistic: weightStatistic,
    })
  }

  if (!recurrenceCallCardVisible && !paidCallCreditsCardVisible) {
    return null
  }

  return (
    <View>
      <View style={styles.container}>
        <Text type="large" bold style={styles.titleText}>
          My Plan
        </Text>

        {recurrenceCallCardVisible && <RecurrenceCallCardProgress {...recurrenceCallCardProps} />}
        {paidCallCreditsCardVisible && <PaidCallCreditsCard {...paidCallCreditsCardProps!} />}
      </View>

      {weightLossUser && (
        <Button
          accessibilityLabel="View Weight Progress"
          onPress={handleOnWeightProgressPress}
          style={styles.button}
          type="outline"
          size="block"
        >
          View your Weight Progress
        </Button>
      )}
    </View>
  )
}

const themedStyle = StyleService.create({
  container: {
    flex: 1,
    marginHorizontal: 16,
    marginTop: 16,
    marginBottom: 8,
    position: 'relative',
  },
  titleText: {
    marginBottom: 8,
  },
  button: {
    height: 40,
    marginHorizontal: 16,
    marginVertical: 8,
  },
})
